import React from 'react';

import { Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { VisibilityRuleSchema } from '@app/models/users';

import { ATTR_META } from '@pages/Employees/data/constants';
import { useRuleValueLabeler } from '@pages/Employees/hooks';
import { isKnownAttribute } from '@pages/Employees/services';

interface IProps {
  rule: VisibilityRuleSchema;
}

export const VisibilityChips: React.FC<IProps> = ({ rule }) => {
  const assignmentsT = useTranslation(NSKeys.assignments);
  const { labelOf } = useRuleValueLabeler(rule);
  const attributeLabel = (attribute: string) =>
    isKnownAttribute(attribute) ? assignmentsT.t(ATTR_META[attribute].labelKey as any) : attribute;

  return (
    <table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse', margin: '12px 0' }}>
      <thead>
        <tr style={{ background: '#fafafa', color: '#8c8c8c', fontSize: 11, letterSpacing: '0.04em' }}>
          <th style={{ textAlign: 'left', padding: '6px 8px', fontWeight: 600 }}>
            {assignmentsT.t('visibility.tableGroup')}
          </th>
          <th style={{ textAlign: 'left', padding: '6px 8px', fontWeight: 600 }}>
            {assignmentsT.t('visibility.tableIncluded')}
          </th>
          <th style={{ textAlign: 'left', padding: '6px 8px', fontWeight: 600 }}>
            {assignmentsT.t('visibility.tableExcluded')}
          </th>
        </tr>
      </thead>
      <tbody>
        {rule.conditions.map((cond, ci) => (
          <tr key={`${cond.attribute}-${ci}`}>
            <td style={{ padding: '6px 8px', borderTop: '1px solid #f5f5f5' }}>
              <Typography.Text>{attributeLabel(cond.attribute)}</Typography.Text>
            </td>
            <td style={{ padding: '6px 8px', borderTop: '1px solid #f5f5f5' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {(cond.include || []).length ? (
                  (cond.include || []).map((v, i) => (
                    <Tag key={`i-${ci}-${i}`} color="blue" style={{ marginInlineEnd: 0 }}>
                      {labelOf(cond.attribute, v)}
                    </Tag>
                  ))
                ) : (
                  <Typography.Text type="secondary">-</Typography.Text>
                )}
              </div>
            </td>
            <td style={{ padding: '6px 8px', borderTop: '1px solid #f5f5f5' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {(cond.exclude || []).length ? (
                  (cond.exclude || []).map((v, i) => (
                    <Tag key={`e-${ci}-${i}`} color="red" style={{ marginInlineEnd: 0 }}>
                      {labelOf(cond.attribute, v)}
                    </Tag>
                  ))
                ) : (
                  <Typography.Text type="secondary">-</Typography.Text>
                )}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
